module.exports = __webpack_public_path__ + "static/dev2-54e37d8074ebcde1d96c77d7b2a7f310.gif";